import { createFileRoute } from "@tanstack/react-router";
import { CustomBotsTable } from "@/components/admin/custom-bots-table";
import { usePageTitle } from "@/hooks/use-page-title";
import { adminCustomBotsQueryOptions } from "@/lib/api/admin";

export const Route = createFileRoute("/dashboard/admin/custom-bots/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(adminCustomBotsQueryOptions({})),
  component: AdminCustomBotsPage,
});

function AdminCustomBotsPage() {
  usePageTitle("Admin - Custom Bots");
  return <CustomBotsTable />;
}
